// Helper function to build the raw HTML for the product QR codes
export const buildProductQRCodes = (content: string) => {
  const styles = `
    .print-page { display: flex; flex-direction: column; align-items: center; gap: 40px; padding: 40px; min-height: 100vh; overflow-y: auto; position: relative; background-color: #f0f0f0; font-family: 'Segoe UI', sans-serif;}
    .page-content { line-height: 1.5; position: relative; padding-top: 2rem; }
    .default-price-note { position: absolute; top: 0; right: 0.7rem; font-size: 0.875rem; color: #666; font-style: italic; }
    .paper { width: 8.5in; height: 11in; background-color: white; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); padding: 0.2in; box-sizing: border-box; page-break-after: always; }
    .section-title { margin-bottom: 1rem; font-size: 1.25rem; font-weight: bold; padding: 0.7rem; }
    .section-title::after { content: ""; display: block; height: 2px; background: #ccc; width: 100%; }
    .product-class-section { break-inside: avoid; }
    .qr-code-grid { display: grid; grid-template-columns: repeat(4, minmax(0,1fr)); grid-auto-rows: 250px; gap: 1rem; width: 100%; }
    .qr-code-item { display: flex; flex-direction: column; align-items: center; justify-content: flex-start; width: 100%; height: 100%; padding: 0.5rem; box-sizing: border-box; aspect-ratio: auto; }
    .qr-code-item img{ max-width: 150px; height: auto;}
    .product-info { margin-top: 0.5rem; text-align: center; width: 100%; }
    .product-name { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    @media print {
      .print-page { padding: 0; gap: 0; }
      .paper { box-shadow: none; margin: 0; height: 10.5in; width: 8.5in; overflow: hidden; }
      .paper:last-of-type { page-break-after: auto; }
      .section-title { page-break-after: avoid; font-size: 1rem; padding: 0.5rem 0; }
      .product-class-section { page-break-inside: avoid; }
    }
  `;

  return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Product QR Codes</title>
            <style>${styles}</style>
        </head>
        <body>${content}</body>
        </html>
    `;
};
